import { render, staticRenderFns } from "./bannerManager.vue?vue&type=template&id=0b57471e&"
import script from "./bannerManager.vue?vue&type=script&lang=js&"
export * from "./bannerManager.vue?vue&type=script&lang=js&"
import style0 from "./bannerManager.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports